export const useQueryParams = (url) => {
    const query = new URLSearchParams(url);
    const getValue = (key) => {
        return query.get(key);
    };
    return { getValue };
};
//# sourceMappingURL=useQueryParams.js.map